import { render } from "./SortBy.vue?vue&type=template&id=60d5124f&scoped=true&ts=true"
import script from "./SortBy.vue?vue&type=script&lang=ts"
export * from "./SortBy.vue?vue&type=script&lang=ts"

import "./SortBy.vue?vue&type=style&index=0&id=60d5124f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d5124f"]])

export default __exports__